import React from 'react'
import { createPortal } from 'react-dom'

import DatePicker from '../DatePicker/DatePicker'

interface CertificationsPortalsProps {
  datePickerState: {
    certId: string
    field: 'startDate' | 'endDate'
    position: { top: number; left: number; width: number }
    triggerKey: string
  } | null
  datePickerRef: React.RefObject<HTMLDivElement>
  editingStartDate: string
  editingEndDate: string
  onDateChange: (value: string) => void
  onClose: () => void
}

export default function CertificationsPortals({
  datePickerState,
  datePickerRef,
  editingStartDate,
  editingEndDate,
  onDateChange,
  onClose,
}: CertificationsPortalsProps) {
  if (!datePickerState) return null

  return createPortal(
    <DatePicker
      ref={datePickerRef}
      value={datePickerState.field === 'startDate' ? editingStartDate : editingEndDate}
      onChange={onDateChange}
      onClose={onClose}
      position={datePickerState.position}
      monthYearOnly={true}
      allowPresent={false}
    />,
    document.body,
  )
}
